import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from '../../../helper/api';

const initialState = {
    isLoading:false,
    status:null,
    error:null
}

export const customerValidatePhone = createAsyncThunk(
    'customer/validateEmail',
    async (data, {rejectWithValue}) => {
        
        const {phone, token} = data;
        try{
            
            const response = await axios.get(`${baseUrl}/Account/validateSMSToken?phone=${phone}&Token=${token}`)
            return response?.data
        } catch (err) {
            
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

const customerValidatePhoneSlice = createSlice({
    name:"customer",
    initialState,
    reducers:{},
    extraReducers:{
        [customerValidatePhone.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [customerValidatePhone.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.data = action.payload;
        },
        [customerValidatePhone.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
            state.error = action.error
        }
    }
})

export default customerValidatePhoneSlice.reducer;